import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Sidebar.css';

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <nav>
        <ul>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          <li>
            <Link to="/landing">Landing Page</Link>
          </li>
          <li>
            <Link to="/index-now">Index Now</Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;

